module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-tablet-738x57.84a8f030.jpg";